<template>
    <div v-if="loading" class="spinner">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
  name: "Loader",
  computed: {
    loading () {
      return this.$store.state.loader.loading;
    }
  }
};
</script>